import React, { FunctionComponent } from 'react';

import {
    SegmentedControl2,
    SegmentedControl2Props,
} from '@yandex-360/orb-components/dist/components/SegmentedControl2';
import cn from 'classnames';

import css from './styles.css';

export const SegmentedControl: FunctionComponent<SegmentedControl2Props> = ({ className, ...props }) => {
    return <SegmentedControl2 className={cn(className, css.responsiveHeight, css.important)} {...props} />;
};
